import React from 'react'
import { WemoloLoading, WemoloTypography } from '../../../components/Wemolo'
import type { ChangeLogEntry } from '../changelog'
import { ChangeLogItemContainer } from '../ChangeLogItem'
import styles from './ChangeLogView.module.css'

interface ChangeLogViewProps {
    entries: ChangeLogEntry[]
    isFetching: boolean
    hasMore: boolean
    onShowMore: () => void
    deviceNameMap: Record<string, string>
    deviceTypeMap: Record<string, string>
}

export const ChangeLogView = ({
    entries,
    isFetching,
    hasMore,
    onShowMore,
    deviceNameMap,
    deviceTypeMap
}: ChangeLogViewProps) => {
    if (isFetching) {
        return (
            <div className={styles.container}>
                <div className={styles.spinnerContainer}>
                    <WemoloLoading />
                </div>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            {entries.length === 0 ? (
                <WemoloTypography variant="body-small" tag="div" className={styles.empty}>
                    No changes recorded
                </WemoloTypography>
            ) : (
                <div className={styles.list}>
                    {entries.map((entry, i) => (
                        <ChangeLogItemContainer
                            key={entry.event_id}
                            entry={entry}
                            isLast={i === entries.length - 1 && !hasMore}
                            deviceNameMap={deviceNameMap}
                            deviceTypeMap={deviceTypeMap}
                        />
                    ))}
                    {hasMore && (
                        <div className={styles.showMore}>
                            <WemoloTypography variant="label-small" tag="span" className={styles.showMoreBtn}>
                                <span onClick={onShowMore}>Show more</span>
                            </WemoloTypography>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
